import { getCollections, getDate, cambiarTextos, getCollectionsComplete } from './functions';
let xlsx = require('json-as-xlsx');

export async function reporteUsuarios() {
	let array = [];
	const results = await getCollections('usuarios');
	// Object.values(results).map((val) => {
	// 	if (val.mx !== '000000') {
	// 		array.push({
	// 			...val,
	// 			asistencia1: val.asistencia1 ? 'Sí' : 'No',
	// 			asistencia2: val.asistencia2 ? 'Sí' : 'No',
	// 			descarga1: val.descarga1 ? 'Sí' : 'No',
	// 			descarga2: val.descarga2 ? 'Sí' : 'No',
	// 		});
	// 	}
	// });
	const fecha = cambiarTextos(getDate());

	let data = [
		{
			sheet: 'Usuarios',
			columns: [
				{ label: 'Nombre', value: 'nombre' },
				{ label: 'Fecha de ingreso', value: 'ingreso' },
			],
			content: results,
		},
	];
	// console.log(array);

	let settings = {
		fileName: `Asistencias-${fecha}`, // Name of the resulting spreadsheet
		extraLength: 3, // A bigger number means that columns will be wider
		writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
	};

	xlsx(data, settings);
}

export async function reporteChats() {
	let array = [];
	const results = await getCollections('chat/sdfdsf800fds8');
	const usuarios = await getCollectionsComplete('usuarios');
	Object.values(results).map((val) => {
		const data = usuarios[val.user];
		array.push({
			nombre: data.nombre,
			mensaje: val.text,
		});
	});
	const fecha = cambiarTextos(getDate());

	let data = [
		{
			sheet: 'USuarios',
			columns: [
				{ label: 'Nombre', value: 'nombre' },
				{ label: 'Mensaje', value: 'mensaje' },
			],
			content: array,
		},
	];
	// console.log(array);

	let settings = {
		fileName: `Chats-${fecha}`, // Name of the resulting spreadsheet
		extraLength: 3, // A bigger number means that columns will be wider
		writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
	};

	xlsx(data, settings);
}

export async function reporteEncuesta() {
	let array = [];
	const results = await getCollections('encuesta');
	const usuarios = await getCollectionsComplete('usuarios');
	Object.values(results).map((val) => {
		const data = usuarios[val.id];
		array.push({
			nombre: data.nombre,
			...val,
		});
	});
	const fecha = cambiarTextos(getDate());

	let data = [
		{
			sheet: 'Encuesta',
			columns: [
				{ label: 'Nombre', value: 'nombre' },
				{ label: '1. La duración de nuestra transmisión fue adecuada:', value: 'pregunta1' },
				{ label: '2. Realizamos una transmisión de calidad:', value: 'pregunta2' },
				{ label: '3. Nuestro contenido fue de interés y entretenido:', value: 'pregunta3' },
				{ label: '4. Te sentiste parte de la transmisión:', value: 'pregunta4' },
				{ label: '5. Comparte un comentario adicional:', value: 'pregunta5' },
				{ label: '6. Te gustaría participar en la siguiente transmisión:', value: 'pregunta6' },
				{ label: 'Registro', value: 'fecha' },
			],
			content: array,
		},
	];
	// console.log(array);

	let settings = {
		fileName: `Encuesta-${fecha}`, // Name of the resulting spreadsheet
		extraLength: 3, // A bigger number means that columns will be wider
		writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
	};

	xlsx(data, settings);
}
